// src/modules/Elements/NormalizeFontSize.tsx
import { useEffect } from 'react';

type Props = {
  /** Tamaño base en px para el scope */
  size?: number;
  /**
   * Selector CSS al que quieres aplicar el font-size.
   * IMPORTANTE: ya no afecta a html/global.
   */
  scopeSelector?: string;
};

/**
 * Normaliza el font-size SOLO dentro de un contenedor (scope).
 * Evita romper toda la app cambiando html { font-size }.
 *
 * Uso recomendado:
 * - RemoteMic.tsx: <NormalizeFontSize size={12} scopeSelector="#phone-ui-container" />
 */
export default function NormalizeFontSize({ size = 16, scopeSelector = '#phone-ui-container' }: Props) {
  useEffect(() => {
    const STYLE_ID = 'normalize-font-size-scoped';
    let styleEl = document.getElementById(STYLE_ID) as HTMLStyleElement | null;

    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = STYLE_ID;
      document.head.appendChild(styleEl);
    }

    // Solo aplica si existe el scope en el DOM
    const scopeExists = document.querySelector(scopeSelector);
    if (!scopeExists) {
      styleEl.textContent = '';
      return;
    }

    styleEl.textContent = `
      ${scopeSelector} {
        font-size: ${size}px;
      }
    `;

    return () => {
      // Limpieza: si cambias de pantalla, evitamos “arrastrar” escalados
      if (styleEl) styleEl.textContent = '';
    };
  }, [size, scopeSelector]);

  return null;
}
